import { render, staticRenderFns } from "./TestTokenRefresh.vue?vue&type=template&id=97cdc46c&scoped=true&"
import script from "./TestTokenRefresh.vue?vue&type=script&lang=js&"
export * from "./TestTokenRefresh.vue?vue&type=script&lang=js&"
import style0 from "./TestTokenRefresh.vue?vue&type=style&index=0&id=97cdc46c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cdc46c",
  null
  
)

export default component.exports